<template>
  <NavigationMenu parent="7"></NavigationMenu>
</template>

<script>
  import { mapGetters } from 'vuex';
  import NavigationMenu from '@/components/NavigationMenu';

  export default {
    name: 'navigation',
    components: { NavigationMenu },
    computed: mapGetters({
      lang: 'lang',
    }),
    watch: {
      lang() {
        this.getData();
      },
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        this.$store.dispatch('fetchNavigation', { lang: this.lang, $http: this.$http });
      },
    },
  };
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Navigation.vue?5e43f2bb